export function getUserInfo(state) {
    return state.userInfo;
  }
  
  
  